export function generateTypeAPolarity(fiberCount) {
    return Array(fiberCount)
        .fill(0)
        .map((v, i) => i + 1);
}

export function generateTypeBPolarity(fiberCount) {
    return Array(fiberCount)
        .fill(0)
        .map((v, i) => fiberCount - i);
}

export function generateTypeCPolarity(fiberCount) {
    return Array(fiberCount)
        .fill(0)
        .map((v, i) => (i % 2 ? i : i + 1 === fiberCount ? 0 : i + 2));
}
